import { importChunk } from "./preload-recovery";

export const loadFilesPage = () =>
  import("../pages/Artifacts").then((module) => module.ArtifactsPage);
export const loadEditorPage = () =>
  import("../pages/TextEditor").then((module) => module.TextEditorPage);
export const loadBriefingPage = () =>
  import("../pages/MissionBriefing").then((module) => module.MissionBriefingPage);

export const loadWorkspacePage = () =>
  import("../pages/Workspace").then((module) => module.WorkspacePage);

/** Start fetching a destination on intent, before navigation needs its lazy component. */
export function preloadHomeDestination(path?: string) {
  const load =
    path === "/app/missions"
      ? () => import("../pages/Missions").then((module) => module.MissionsPage)
      : path === "/app/artifacts"
        ? loadFilesPage
        : path === "/app/editor"
          ? loadEditorPage
          : path === "/app/mission-briefing"
            ? loadBriefingPage
            : path?.startsWith("/app/projects")
              ? () => import("../pages/Projects").then((module) => module.ProjectsPage)
              : path?.startsWith("/app/workspace/")
                ? loadWorkspacePage
                : undefined;
  if (load) void importChunk(load).catch(() => undefined);
}
